import React, { FC, useMemo, useState } from 'react'
import { VStack, Image } from '@chakra-ui/react'
import { cardImageMap } from '../../state/interfaces'
import { DatePicker } from 'antd'
import moment from 'moment'

export interface InputDatePickerProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
  grandImage?: string
}

export const InputDatePicker: FC<InputDatePickerProps> = ({ placeholder, onChange, grandImage }) => {
  const [dateValue, setDateValue] = useState<moment.Moment | null>(null)
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  // const { t } = useTranslation()

  // const handleOnClick = () => {
  //   onChange && onChange([''])
  // }

  const handleDateChange = (date: moment.Moment | null) => {
    setDateValue(date)
    onChange && onChange([date?.format('YYYY/MM/DD') || ''])
  }

  return (
    <VStack spacing={4} marginY={8} gridRowGap={4}>
      <div onClick={(e) => e.stopPropagation()}>
        <DatePicker
          onChange={handleDateChange}
          format="DD/MM/YYYY"
          size="large"
          value={dateValue}
          placeholder={placeholder}
          disabledDate={(current) => current && current < moment().startOf('day')}
          inputReadOnly // This will make the input read-only, preventing the native date picker from appearing
        />
      </div>
      {/* <Button role={'button'} layerStyle={theme.LayerStyles.SMALL_PILL} onClick={handleOnClick}>
        <Box color="white" fontSize={16}>
          {t('common_skip')}
        </Box>
      </Button> */}
      <Image src={image} alt="image" width={['0', '250px']} height={['0', '250px']} />
    </VStack>
  )
}
